export enum eTitleFees {
  abstract_and_exam = 'abstract_and_exam',
  acris = 'acris',
  attorney = 'attorney',
  attorney_document_review = 'attorney_document_review',
  closer = 'closer',
  closing = 'closing',
  commitment = 'commitment',
  coordination = 'coordination',
  cpl_borrower = 'cpl_borrower',
  cpl_buyer = 'cpl_buyer',
  cpl_lender = 'cpl_lender',
  cpl_seller = 'cpl_seller',
  document_preparation = 'document_preparation',
  document_copies = 'document_copies',
  escrow = 'escrow',
  exam = 'exam',
  extended_lenders_policy = 'extended_lenders_policy',
  hoi_endorsement = 'hoi_endorsement',
  hold_open = 'hold_open',
  homeowners_policy = 'homeowners_policy',
  lenders_policy = 'lenders_policy',
  lenders_policy_guaranty = 'lenders_policy_guaranty',
  lenders_state_policy = 'lenders_state_policy',
  lenders_title_guaranty = 'lenders_title_guaranty',
  municipal_lien_certification = 'municipal_lien_certification',
  owners_title_guaranty = 'owners_title_guaranty',
  owners_policy_guaranty = 'owners_policy_guaranty',
  owners_state_policy = 'owners_state_policy',
  recording_processing = 'recording_processing',
  search = 'search',
  search_report = 'search_report',
  settlement = 'settlement',
  standard_owners_policy = 'standard_owners_policy',
  sub_escrow = 'sub_escrow',
  survey = 'survey',
  tax_certification = 'tax_certification',
  tieff_lenders_policy = 'tieff_lenders_policy',
  tieff_owners_policy = 'tieff_owners_policy',
  title_closing = 'title_closing',
  title_opinion = 'title_opinion',
  updated_search = 'updated_search',
  updated_tax_certification = 'updated_tax_certification',
}
